import React, { useEffect, useState } from "react";
import { KeyRound, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import { api, formatApiError, PERM_LABELS, ROLE_LABELS } from "@/lib/api";

const ROLES = Object.entries(ROLE_LABELS);

export default function PermissionsManager() {
  const [perms, setPerms] = useState([]);
  const [roles, setRoles] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings/permissions").then((r) => { setPerms(r.data.perms); setRoles(r.data.roles); }).catch(() => {});
  }, []);

  const toggle = (role, p) => setRoles((r) => { const cur = r[role] || []; return { ...r, [role]: cur.includes(p) ? cur.filter((x) => x !== p) : [...cur, p] }; });
  const save = async () => {
    setSaving(true);
    try { const r = await api.post("/admin/settings/permissions", { roles }); setRoles(r.data.roles); toast.success("Permissões salvas!"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="permissions-manager">
      <div className="flex items-center gap-2">
        <KeyRound className="h-5 w-5 text-[#1B7A45]" />
        <h2 className="font-display text-xl font-bold tracking-tight text-slate-900">Controle de permissões</h2>
      </div>
      <p className="mt-1 text-sm text-slate-500">Marque o que cada cargo pode fazer. O proprietário (esportesdubal@gmail.com) sempre tem acesso total. Atribua cargos em Usuários → Equipe de administração.</p>
      <div className="mt-4 overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-slate-100 text-left text-xs uppercase tracking-wider text-slate-500"><th className="px-4 py-3">Área / ação</th>{ROLES.map(([k, l]) => <th key={k} className="px-4 py-3 text-center">{l}</th>)}</tr></thead>
          <tbody>
            {perms.map((p) => (
              <tr key={p} className="border-b border-slate-50 last:border-0">
                <td className="px-4 py-3 font-medium text-slate-700">{PERM_LABELS[p] || p}</td>
                {ROLES.map(([k]) => (
                  <td key={k} className="px-4 py-3 text-center">
                    <Checkbox data-testid={`perm-${k}-${p}`} checked={roles[k]?.includes(p)} onCheckedChange={() => toggle(k, p)} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Button data-testid="perm-save" onClick={save} disabled={saving} className="mt-4 rounded-full bg-[#1B7A45] px-6 text-white hover:bg-[#156337]"><Save className="mr-1.5 h-4 w-4" /> {saving ? "Salvando..." : "Salvar permissões"}</Button>
    </div>
  );
}
